import { format, unwrapFunctionStore } from 'svelte-i18n';

import { integrationsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT, GLOBAL_LOADER_STEP } from '@client/enums';

import { clickCreateIntegration } from '../create/click-create-integration';
import { clickNewIntegration } from '../create/click-new-integration';
import { creatingIntegration } from '../create/creating-integration';
import {
  fallbackText,
  integrationForm,
  parameters,
  paramsHideField,
  paramsRemoveField,
  rulename
} from '../create/form';
import { clickAProvider, providerOptions, requestingNewProvider } from '../create/options';
import { accessingIntegrationEditor, editActionsMenu } from '../edit/accessing-integration-editor';
import { editingIntegration } from '../edit/editing-integration';
import { savingIntegration } from '../edit/save';
import { updatingIntegration } from '../edit/updating-integration';
import {
  diagnosticsHtmlSource,
  diagnosticsRenderedHtml,
  diagnosticsRenderedText,
  diagnosticsShowMore,
  diagnosticsTool
} from '../edit/viewing-diagnostics';
import { integrationsActionsMenu, integrationsCard, integrationsRulename } from '../overview/card';
import { integrationsOverview } from '../overview/overview';

const $format = unwrapFunctionStore(format);

let fullSteps = [
  integrationsOverview,
  integrationsCard,
  integrationsActionsMenu,
  integrationsRulename,
  creatingIntegration,
  clickNewIntegration,
  providerOptions,
  requestingNewProvider,
  clickAProvider,
  integrationForm,
  rulename,
  parameters,
  paramsHideField,
  paramsRemoveField,
  fallbackText,
  clickCreateIntegration,
  editingIntegration,
  accessingIntegrationEditor,
  editActionsMenu,
  GLOBAL_LOADER_STEP,
  updatingIntegration,
  diagnosticsShowMore,
  diagnosticsHtmlSource,
  diagnosticsRenderedHtml,
  diagnosticsRenderedText,
  diagnosticsTool,
  savingIntegration
];

fullSteps[3] = {
  ...fullSteps[3],
  popover: {
    ...fullSteps[3].popover,
    nextBtnText: "Next <i class='os-icon-arrow-right'></i> Create Tour",
    onNextClick: () => {
      integrationsSettingsStore.update((integrations) => {
        return {
          ...integrations,
          tours: {
            ...integrations.tours,
            overviewHasToured: true
          }
        };
      });

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

fullSteps[4] = {
  ...fullSteps[4],
  popover: {
    ...fullSteps[4].popover,
    showButtons: ['next']
  }
};

fullSteps[15] = {
  ...fullSteps[15],
  popover: {
    ...fullSteps[15].popover,
    nextBtnText: "Next <i class='os-icon-arrow-right'></i> Editing Tour",
    onNextClick: () => {
      const close = document.querySelector('.close');

      if (close) {
        integrationsSettingsStore.subscribe((integrations) => {
          integrations.tours.createHasToured = true;
        })();

        close.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

fullSteps[16] = {
  ...fullSteps[16],
  popover: {
    ...fullSteps[16].popover,
    showButtons: ['next']
  }
};

fullSteps[19] = {
  ...fullSteps[19],
  popover: {
    ...fullSteps[19].popover,
    title: 'Loading integration...'
  }
};

fullSteps[26] = {
  ...fullSteps[26],
  popover: {
    ...fullSteps[26].popover,
    onNextClick: () => {
      const cancelBtn = document.querySelector('button.hide--mobile.me-2.btn.btn-secondary');

      integrationsSettingsStore.subscribe((integrations) => {
        integrations.tours = {
          ...integrations.tours,
          hasToured: true,
          editHasToured: true
        };
      })();

      if (cancelBtn) {
        cancelBtn.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};

export const FULL_STEPS = fullSteps;
